import { __decorate, __metadata, __param } from "tslib";
import { fetchFrequentlyAskedQuestions } from '@gn-audio/core/api/knowledge-base';
import { Component, Inject, Input, Output } from 'angular-ts-decorators';
import { FaqTeasersService } from './faq-teasers.service';
import { generateFaqUrl } from '../utils/generate-faq-url';
import template from './faq-teasers.component.html';
var FaqTeasersComponent = (function () {
    function FaqTeasersComponent($q, $scope, faqTeasersService) {
        this.$q = $q;
        this.$scope = $scope;
        this.faqTeasersService = faqTeasersService;
        this.excludeFaqCodes = [];
    }
    Object.defineProperty(FaqTeasersComponent.prototype, "visible", {
        get: function () {
            var _a;
            return this.faqTeasersService.teasersVisible && ((_a = this.faqTeasers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    FaqTeasersComponent.prototype.ngOnChanges = function () {
        var _this = this;
        if (!this.group) {
            this.faqTeasers = [];
            this.notify();
            return;
        }
        this.$q.when(fetchFrequentlyAskedQuestions(this.group.groupId))
            .then(function (faqItems) {
            _this.faqTeasers = (faqItems || [])
                .filter(function (x) { return !!x.didYouKnow; })
                .filter(function (x) { return _this.excludeFaqCodes.indexOf(x.code) === -1; })
                .sort(function () { return Math.random() - 0.5; });
            _this.notify();
        });
    };
    FaqTeasersComponent.prototype.getFaqUrl = function (faqTeaser) {
        return generateFaqUrl(this.group, faqTeaser.id);
    };
    FaqTeasersComponent.prototype.beforeChange = function () {
        this.$scope.$broadcast('resetLiveTyping');
    };
    FaqTeasersComponent.prototype.notify = function () {
        if (!this.onFaqTeasersLoad) {
            return;
        }
        this.onFaqTeasersLoad({ faqTeasers: this.faqTeasers });
    };
    FaqTeasersComponent.$inject = [];
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], FaqTeasersComponent.prototype, "group", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], FaqTeasersComponent.prototype, "excludeFaqCodes", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Function)
    ], FaqTeasersComponent.prototype, "onFaqTeasersLoad", void 0);
    FaqTeasersComponent = __decorate([
        Component({
            selector: 'faqTeasers',
            template: template,
        }),
        __param(0, Inject('$q')),
        __param(1, Inject('$scope')),
        __param(2, Inject('faqTeasersService')),
        __metadata("design:paramtypes", [Function, Object, FaqTeasersService])
    ], FaqTeasersComponent);
    return FaqTeasersComponent;
}());
export { FaqTeasersComponent };
